export default __webpack_public_path__ + "static/media/torta.cbd48a8b.png";